module.exports = __webpack_public_path__ + "static/media/excel.15ae9042.svg";